// @flow
import React from 'react';
import type { ChildrenArray, Element } from 'react';
import { usePropsValidation } from '../validation/runtime-checks/index.js';
import bullet from './bullet.svg';
import { Text } from '../Text.js';
import { types as t } from '../validation/runtime-checks/prop-spec.js';
import { Heading } from '../Heading.js';
import { productColor } from '../designSystem.js';

export function TOVFKItem(props: {|
  benchmark: string,
  children: React$Node,
|}) {
  const { failedValidation } = usePropsValidation(props, TOVFKItem);
  if (failedValidation) return null;
  return (
    <li
      style={{
        listStylePosition: 'outside',
        listStyleImage: `url('${bullet}')`,
        marginBottom: 12,
      }}
    >
      ({props.benchmark}) {props.children}
    </li>
  );
}
TOVFKItem.spec = {
  benchmark: t.string,
  children: Text.spec.children,
};

export function TOVFoundationalKnowledgeList(props: {|
  children: ChildrenArray<Element<typeof TOVFKItem>>,
|}) {
  const { failedValidation } = usePropsValidation(
    props,
    TOVFoundationalKnowledgeList,
  );
  if (failedValidation) return null;
  return (
    <div style={{ color: productColor.shuttleGrey }}>
      <Heading>Foundational knowledge</Heading>
      <ul style={{ padding: 16 }}>{props.children}</ul>
    </div>
  );
}

TOVFoundationalKnowledgeList.spec = {
  children: t.minimumCount(1, t.elementType(TOVFKItem)),
};
